import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  CreateSavedFilter as CreateSavedFilterGenerated,
  CreateSavedFilterVariables as CreateSavedFilterVariablesGenerated,
} from "core/queries/__generated__/CreateSavedFilter";

export interface CreateSavedFilterResponse extends CreateSavedFilterGenerated {}
export interface CreateSavedFilterVariables
  extends CreateSavedFilterVariablesGenerated {}

export const createSavedFilter = gql`
  mutation CreateSavedFilter(
    $name: String!
    $description: String
    $ownerId: ID!
    $ownerType: FilterOwner!
    $filter: TaskFilterInput!
  ) {
    createSavedTomFilter(
      name: $name
      description: $description
      filter: $filter
      ownerId: $ownerId
      ownerType: $ownerType
    ) {
      newSavedFilter {
        id
        name
        description
        filter {
          city
          status
          priority
          dueAtStart
          dueAtEnd
          triaged
          buildingIds
          duringStay
          occupancy
          clientType
          tomTags
          assignee
          taskType
        }
        ownerId
        ownerType
      }
    }
  }
`;

interface UseCreateSavedFilterQueryOptions {
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: CreateSavedFilterResponse) => void;
  refetchQueries?: string[];
}
export const useCreateSavedFilter = ({
  awaitRefetchQueries = false,
  onCompleted,
  refetchQueries = [],
}: UseCreateSavedFilterQueryOptions) =>
  useMutation<CreateSavedFilterResponse, CreateSavedFilterVariables>(
    createSavedFilter,
    {
      awaitRefetchQueries,
      onCompleted,
      refetchQueries,
    },
  );
